import { useMemo, useState } from "react";

import { SearchOrganizationsByEnum } from "@organization/models/Organization";

import { SearchOrganizationsContext } from "./SearchOrganizationsContext";

export const SearchOrganizationsContextProvider = ({ children }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [searchBy, setSearchBy] = useState(SearchOrganizationsByEnum.ByName);

  const value = useMemo(() => {
    return {
      searchQuery,
      setSearchQuery,
      searchBy,
      setSearchBy
    };
  }, [searchQuery, searchBy]);

  return (
    <SearchOrganizationsContext.Provider value={value}>
      {children}
    </SearchOrganizationsContext.Provider>
  );
};
